import { Component } from '@angular/core';


export class SkyKeyInfoDemoComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-key-info-demo',
  template: `<h3>
  Vertical example
</h3>

<sky-key-info>
  <sky-key-info-value>
    This is a default sample value.
  </sky-key-info-value>
  <sky-key-info-label>
    This is a default sample label.
  </sky-key-info-label>
</sky-key-info>
<sky-key-info>
  <sky-key-info-value>
    This is another default sample value.
  </sky-key-info-value>
  <sky-key-info-label>
    This is another default sample label.
  </sky-key-info-label>
</sky-key-info>

<h3>
  Horizontal example
</h3>

<sky-key-info
  layout="horizontal">
  <sky-key-info-value>
    This is a horizontal sample value.
  </sky-key-info-value>
  <sky-key-info-label>
    This is a horizontal sample label.
  </sky-key-info-label>
</sky-key-info>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
